import React from "react";
import NyugdijasPromocioModel from "../components/promociosoldal copy/nyugdijaspromocio";

const NyugdijasPromocio = () => {
  return <NyugdijasPromocioModel />;
};

export default NyugdijasPromocio;
